import React from 'react';

import { StyledAdditionalBaseOption } from './AdditionalBaseOption.styles';

import { AdditionalBaseOptionProps } from './AdditionalBaseOption.types';

const AdditionalBaseOption = ({
  children,
  handleClick,
  componentClassname = 'additional-base-option',
  customClassnames = '',
  customStyle = '',
}: AdditionalBaseOptionProps) => {
  return (
    <StyledAdditionalBaseOption
      className={`${componentClassname} ${customClassnames}`}
      customStyle={customStyle}
      onClick={handleClick}
    >
      {children}
    </StyledAdditionalBaseOption>
  );
};
AdditionalBaseOption.displayName = 'AdditionalBaseOption';

export default AdditionalBaseOption;
